import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import axios from 'axios';
import WINWorker from "../../Services/WINWorker";


export default function PartnerMessagePanel(props) {
    const [filterOpen, setfilterOpen] = React.useState(true);
    const [isUser, setIsUser] = React.useState(false);
    const {t, i18n} = useTranslation();
    const [formData, setFormData] = useState({
        message_from_name: '',
        message_from_email: '',
        message_from_phone: '',
        message_role: '',
        message_location: '',
        message_sqft: '',
        message_building_type: '',
        message_inquiry_status: '',
        message_body: '',
        names: '{listnames}', // Hidden field from original form
        user_id: '{user_id}' // Hidden field from original form
    });

    // Validation state
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [submitError, setSubmitError] = useState('');


    useEffect(() => {
        if (typeof window.is_user !== 'undefined') {
            if (window.is_user === 'True') {
                if (window.user_email.trim()) {
                    formData.message_from_email = window.user_email;
                }
                if (window.user_name.trim()) {
                    formData.message_from_name = window.user_name;
                }
                setIsUser(true);
            }
            console.log('is_user', window.is_user);
            console.log('isUser', isUser);
        }
    });

    // Handle input changes
    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData({
            ...formData,
            [name]: value
        });

        // Clear error for the field being edited
        if (errors[name]) {
            setErrors({
                ...errors,
                [name]: ''
            });
        }
    };

    // Handle radio button changes
    const handleRadioChange = (e) => {
        setFormData({
            ...formData,
            message_inquiry_status: e.target.value
        });

        // Clear error for inquiry status
        if (errors.message_inquiry_status) {
            setErrors({
                ...errors,
                message_inquiry_status: ''
            });
        }
    };

    // Validate form
    const validateForm = () => {
        const newErrors = {};
        console.log('formData', formData);

        // Required fields
        if (!formData.message_from_name.trim()) {
            newErrors.message_from_name = 'Name is required';
        }

        if (!formData.message_from_email.trim()) {
            newErrors.message_from_email = 'Email is required';
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.message_from_email)) {
            newErrors.message_from_email = 'Invalid email address';
        }

        if (!formData.message_from_phone.trim()) {
            newErrors.message_from_phone = 'Invalid phone number';
            console.log('Invalid phone number', formData);
        }

        if (!formData.message_body.trim()) {
            newErrors.message_body = 'Message is required';
        }

        // Set errors and return validation result
        setErrors(newErrors);
        console.log('newErrors', newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Submit form - using Promises instead of async/await
    const handleSubmit = (e) => {
        e.preventDefault();

        let partnerList = props.partners.map((item) => {
            if (!item.isToggled) {
                return item.objectID;
            }
            return null; // Explicitly return null for items that don't match the condition
        });

        formData.names = partnerList;
        formData.message_source = window.location.pathname;

        console.log('formData', formData);

        if (!validateForm()) {
            return;
        }

        setIsSubmitting(true);
        setSubmitError('');

        WINWorker.createPartnerMessage(formData)
            .then(function (response) {
                console.log(response);
                window.toastr.success('Message Sent Successfully!');
                if (response) {
                    setSubmitSuccess(true);
                    // Reset form
                    setFormData({
                        message_from_name: '',
                        message_from_email: '',
                        message_from_phone: '',
                        message_role: '',
                        message_location: '',
                        message_sqft: '',
                        message_building_type: '',
                        message_inquiry_status: '',
                        message_body: '',
                        names: '{listnames}',
                        user_id: '{user_id}'
                    });

                    // Show success message or redirect
                    setTimeout(function () {
                        window.location.reload();
                        //props.onMessageCancel(); // Close modal or return to partner selection
                    }, 1000);
                }
            })
            .catch(function (error) {
                console.error('Error submitting form:', error);

                // React 16 compatible error handling
                let errorMessage = 'There was an error submitting your message. Please try again.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                setSubmitError(errorMessage);
            })
            .finally(function () {
                setIsSubmitting(false);
            });
    };


    const ZZhandleChange = () => {
        setfilterOpen(!filterOpen);
        const btn_el = document.querySelector(".js-btn-filter");
        const panel_el = document.querySelector(".js-filters-panel");


        btn_el.classList.toggle('open');
        panel_el.classList.toggle('filters-open');


    };

    const list = props.partners.map((item) => {
        if (!item.isToggled) {
            return (
                <React.Fragment key={item.name}>
                    <div
                        className="tag form__tag"
                        onClick={(event) => {
                            event.preventDefault();
                            props.onRemovePartner(item);
                        }}
                    >
                        <span>{item.name}</span>
                        <a href="#" className="remove" tabIndex="-1" title="Remove">
                            x
                        </a>
                    </div>
                </React.Fragment>
            );
        }
        return null; // Explicitly return null for items that don't match the condition
    });

    const noPartnersSet = props.partners.every(item => item.isToggled === true);
    if (noPartnersSet) {
        console.log('f');
        props.onMessageCancel();
    }

    return (
        <div className="form partner-form-contact-message">
            {submitSuccess ? (
                <div className="success-message">
                    <h3>Message Sent Successfully!</h3>
                    <p>Thank you for your inquiry.</p>
                </div>
            ) : (
                <form method="post" action="" id="messageForm" onSubmit={handleSubmit}>

                    <div className="form__row">

                        <label htmlFor="id_message_from_name" className="form__label">You are contacting:</label>
                        <div className="form__tags">{list}</div>

                    </div>

                    <div className="form__row form__group col-3of4">
                        <label htmlFor="id_message_from_name" className="form__label">Name</label>
                        <input
                            type="text"
                            name="message_from_name"
                            value={formData.message_from_name}
                            onChange={handleChange}
                            required
                            className={`form-control form-control-name ${errors.message_from_name ? 'error' : ''}`}
                            placeholder="First Last..."
                            maxLength="255"
                            id="id_message_from_name"
                            disabled={isUser}
                        />
                        {errors.message_from_name && <span className="error-message">{errors.message_from_name}</span>}
                    </div>

                    <div className="form__row form__group col-3of4">
                        <label htmlFor="id_message_from_email" className="form__label">Email</label>
                        <input
                            type="email"
                            name="message_from_email"
                            value={formData.message_from_email}
                            onChange={handleChange}
                            required
                            className={`form-control form-control-name ${errors.message_from_email ? 'error' : ''}`}
                            placeholder="you@email.com"
                            maxLength="255"
                            id="id_message_from_email"
                            disabled={isUser}
                        />
                        {errors.message_from_email &&
                            <span className="error-message">{errors.message_from_email}</span>}
                    </div>

                    <div className="form__row form__group col-1of2">
                        <label htmlFor="id_message_from_phone" className="form__label">Phone Number</label>
                        <input
                            type="text"
                            name="message_from_phone"
                            value={formData.message_from_phone}
                            onChange={handleChange}
                            className={`form-control form-control-name ${errors.message_from_phone ? 'error' : ''}`}
                            placeholder="555-555-5555"
                            maxLength="255"
                            required
                            id="id_message_from_phone"
                        />
                        {errors.message_from_phone &&
                            <span className="error-message">{errors.message_from_phone}</span>}
                    </div>

                    <div className="form__row form__group col-3of4">
                        <label htmlFor="id_message_location" className="form__label">Project City & State</label>
                        <input
                            type="text"
                            name="message_location"
                            value={formData.message_location}
                            onChange={handleChange}
                            className="form-control form-control-name"
                            placeholder="City, State"
                            maxLength="255"
                            required
                            id="id_message_location"
                        />
                    </div>

                    <div className="form__row form__group col-1of2">
                        <label htmlFor="id_message_role" className="form__label">Role on Project</label>
                        <input
                            type="text"
                            name="message_role"
                            value={formData.message_role}
                            onChange={handleChange}
                            className="form-control form-control-name"
                            placeholder="Structural Engineer"
                            maxLength="255"
                            required
                            id="id_message_role"
                        />
                    </div>

                    <div className="form__row form__group col-1of2">
                        <label htmlFor="id_message_sqft" className="form__label">Project Square Footage</label>
                        <input
                            type="text"
                            name="message_sqft"
                            value={formData.message_sqft}
                            onChange={handleChange}
                            className="form-control form-control-name"
                            placeholder="27,000"
                            maxLength="255"
                            required
                            id="id_message_sqft"
                        />
                    </div>

                    <div className="form__row form__group col-1of2">
                        <label htmlFor="id_message_building_type" className="form__label">Project Building Type</label>
                        <input
                            type="text"
                            name="message_building_type"
                            value={formData.message_building_type}
                            onChange={handleChange}
                            className="form-control form-control-name"
                            placeholder="Business (Office)"
                            maxLength="255"
                            required
                            id="id_message_building_type"
                        />
                    </div>

                    <div className="form__row">
                        <label className="form__label">Is This Inquiry Related To</label>
                        <div className="radios">
                            <div className="radio">
                                <input
                                    type="radio"
                                    name="message_inquiry_status"
                                    id="field-1"
                                    value="For Budgeting"
                                    checked={formData.message_inquiry_status === "For Budgeting"}
                                    onChange={handleRadioChange}
                                />
                                <label htmlFor="field-1">For Budgeting</label>
                            </div>
                            <div className="radio">
                                <input
                                    type="radio"
                                    name="message_inquiry_status"
                                    id="field-2"
                                    value="For Awarding"
                                    checked={formData.message_inquiry_status === "For Awarding"}
                                    onChange={handleRadioChange}
                                />
                                <label htmlFor="field-2">For Awarding</label>
                            </div>
                        </div>
                        {errors.message_inquiry_status &&
                            <span className="error-message">{errors.message_inquiry_status}</span>}
                    </div>

                    <div className="form__row">
                        <label htmlFor="id_message_body" className="form__label">Message:</label>
                        <textarea
                            name="message_body"
                            value={formData.message_body}
                            onChange={handleChange}
                            cols="40"
                            rows="7"
                            className={`field textarea ${errors.message_body ? 'error' : ''}`}
                            placeholder="Your Message..."
                            required
                            id="id_message_body"
                        ></textarea>
                        {errors.message_body && <span className="error-message">{errors.message_body}</span>}
                    </div>

                    <div className="form__row">
                        <p>By sending, I confirm this is an inquiry, not a promotional message or solicitation.</p>
                        <center>
                            <button
                                type="submit"
                                id="btnCaptchaSend"
                                className="submit-btn btn btn-primary"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Sending...' : 'Send Message'}
                            </button>
                        </center>
                    </div>

                    {submitError && <div className="submit-error">{submitError}</div>}
                </form>
            )}
        </div>
    );
}
